'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';
import * as Sentry from '@sentry/nextjs';

export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            gap: '16px',
            padding: '24px',
            fontFamily: 'system-ui, sans-serif'
          }}
        >
          <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#18181b' }}>
            Something went wrong
          </h2>
          <p
            style={{
              fontSize: '14px',
              color: '#71717a',
              maxWidth: '400px',
              textAlign: 'center'
            }}
          >
            An unexpected error occurred. Please try again.
          </p>
          <button
            onClick={reset}
            style={{
              borderRadius: '6px',
              backgroundColor: '#18181b',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 500,
              color: 'white',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
